import PrimaryButton from "elements/Button/PrimaryButton/PrimaryButton";

import {ForgotPasswordTexts} from "i18n/containers/ForgotPassword";
import {ForgotPasswordTranslation} from "i18n/containers/ForgotPassword/typing";
import {ValidationsMessageTexts} from "i18n/ValidationsMessage";
import {ValidationMessageTranslation} from "i18n/ValidationsMessage/typing";
import * as React from "react";
import Form from "semantic-ui-react/dist/commonjs/collections/Form";
import Grid from "semantic-ui-react/dist/commonjs/collections/Grid";
import {isValidEmail} from "@utils";
import {Field} from "../Field/Field";
import {FieldProps, FieldStyle} from "../Field/typing";
import {FormForgotPasswordProps} from "./typing";

const getEmailField = Symbol();

export class FormForgotPassword extends React.PureComponent<FormForgotPasswordProps> {
    state = {
        hasValidEmail: false,
    };

    [getEmailField] = (): FieldProps => {
        const {currentShortLocale} = this.props;
        const validationsTranslation: ValidationMessageTranslation = {
            ...ValidationsMessageTexts[currentShortLocale],
        };

        return {
            label: "Email",
            onChange: (email: string) => {
                const validation = isValidEmail(email) ? "" : validationsTranslation.checkEmail;
                this.setState({
                    hasValidEmail: !Boolean(validation),
                });

                this.props.onChangeEmail(email);
            },
            validate: (valueToValidate: string) => {
                const validation = isValidEmail(valueToValidate) ? "" : validationsTranslation.checkEmail;
                this.setState({
                    hasValidEmail: !Boolean(validation),
                });

                return validation;
            },
            type: {
                style: FieldStyle.INPUT,
                placeholder: "vinglet@example.com",
                icon: "mail",
            },
        };
    };

    onClickContinueButton = () => {
        const {onSubmit, onFormError, currentShortLocale} = this.props;
        const {hasValidEmail} = this.state;
        const forgotPasswordTranslation: ForgotPasswordTranslation = {
            ...ForgotPasswordTexts[currentShortLocale],
        };

        if (hasValidEmail) {
            onSubmit();
        } else {
            onFormError(forgotPasswordTranslation.emptyFields);
        }
    };

    render() {
        const {loading, currentShortLocale} = this.props;
        const forgotPasswordTranslation: ForgotPasswordTranslation = {
            ...ForgotPasswordTexts[currentShortLocale],
        };

        return (
            <Form className="FormForgotPassword">
                <Field {...this[getEmailField]()} />
                <Grid padded={true}>
                    <Grid.Column width="16">
                        <div className="padding-2-top">
                            <PrimaryButton
                                fluid
                                size={"medium"}
                                loading={loading}
                                type="submit"
                                labelButton={forgotPasswordTranslation.continue}
                                animatedButton
                                onClick={this.onClickContinueButton}
                            />
                        </div>
                    </Grid.Column>
                </Grid>
            </Form>
        );
    }
}
